<template>
  <div class="charts-box">
    <qiun-vue-ucharts 
      type="ring"
      :opts="opts"
      :chartData="ringData"
    />
  </div>
</template>

<script>
// 需要在您的项目内执行 npm i @qiun/vue-ucharts
import qiunVueUcharts from '@qiun/vue-ucharts'

export default {
  components: {
    qiunVueUcharts
  },
  props: {
      ringData: {
          type: Object,
          default: () => {}
      },
      ringTitle: {
          type: Object,
          default: () => {}
      }
  },
  data() {
    return {
      chartData: {},
      //您可以通过修改 config-ucharts.js 文件中下标为 ['ring'] 的节点来配置全局默认参数，如都是默认参数，此处可以不传 opts 。实际应用过程中 opts 只需传入与全局默认参数中不一致的【某一个属性】即可实现同类型的图表显示不同的样式，达到页面简洁的需求。
      opts: {
        rotate: false,
        rotateLock: false,
        color: ["#1890FF","#91CB74","#FAC858","#EE6666","#73C0DE","#3CA272","#FC8452","#9A60B4","#ea7ccc"],
        padding: [5,5,5,5],
        dataLabel: true,
        enableScroll: false,
        legend: {
          show: true,
          position: "right",
          lineHeight: 25
        },
        title: {
          name: "用户",
          fontSize: 15,
          color: "#666666"
        },
        subtitle: {
          name: "100%",
          fontSize: 25,
          color: "#7cb5ec"
        },
        extra: {
          ring: {
            ringWidth: 60,
            activeOpacity: 0.5,
            activeRadius: 10,
            offsetAngle: 0,
            labelWidth: 15,
            border: true,
            borderWidth: 3,
            borderColor: "#FFFFFF",
            linearType: "custom"
          }
        }
      }
    };
  },
  watch: {
    ringTitle: {
      handler(newVal, oldVal) {
        console.log(newVal,'123456');
        this.opts.title.name = newVal.name;
        this.opts.subtitle.name = newVal.subtitle;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // this.getServerData();
  },
  methods: {
    // getServerData() {
    //   //模拟从服务器获取数据时的延时
    //   setTimeout(() => {
    //     //模拟服务器返回数据，如果数据格式和标准格式不同，需自行按下面的格式拼接
    //     let res = {
    //         series: [
    //           {
    //             data: [{"name":"酒店销售","value":50},{"name":"采购人员","value":30}]
    //           }
    //         ]
    //       };
    //     this.chartData = JSON.parse(JSON.stringify(res));
    //   }, 500);
    // },
  }
};
</script>

<style scoped>
  /* 请根据实际需求修改父元素尺寸，组件自动识别宽高 */
  .charts-box {
    width: 450px;
    height: 300px;
  }

</style>